// extracted by mini-css-extract-plugin
export default {"container":"pH-z","disabled":"qH-z","bgBlack":"rH-z","content":"sH-z","countdown":"tH-z","topCaption":"uH-z","topHeading":"vH-z","heading":"wH-z","copy":"xH-z"};